import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapActions, mapGetters, mapState } from 'vuex'
import { CustomFieldsForm } from '@kwixeo/custom-fields-vue'
import { Spinner, CivilitySelect, TagSelect, emitter } from '@kwixeo/interface-vue'
import { BRow, BCol, BFormRow, BFormGroup, BFormRadioGroup, BFormRadio } from 'bootstrap-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { KForm, KFormSelect, KFormInput, KFormPhone, KFormAddress, KFormEditor, KFormCheckbox } from '@kwixeo/form-vue'
import { AxiosResponse } from 'axios'
import { needFetchContact, fetchContact } from '../../fetchDatas/contact'
import CustomerSelect from '../CustomerSelect/CustomerSelect.vue'
import editorConfig from './editorConfig'

@Component({
  computed: {
    ...mapState('globalDatas', ['countries']),
    ...mapGetters('user', ['team', 'teamConfigs']),
    ...mapState('customers', ['contactFunctions']),
    ...mapGetters('customers', ['defaultContactFunction']),
  },
  methods: {
    ...mapActions('globalDatas', ['loadCountries']),
    ...mapActions('customers', ['loadContactFunctions'])
  },
  components: {
    CustomerSelect,
    CustomFieldsForm,
    Spinner,
    CivilitySelect, TagSelect,
    KForm, KFormSelect, KFormInput, KFormPhone, KFormAddress, KFormEditor, KFormCheckbox,
    BRow, BCol, BFormRow, BFormGroup, BFormRadioGroup, BFormRadio,
    FontAwesomeIcon
  }
})
export default class ContactForm extends Vue {
  loadCountries!: (force?: boolean) => void
  team!: KwixeoFramework.Team
  teamConfigs!: KwixeoFramework.ConfigAttributes
  contactFunctions!: KwixeoCustomers.ContactFunctions
  defaultContactFunction!: KwixeoCustomers.ContactFunction
  loadContactFunctions!: (force?: boolean) => void

  @Prop({ default: null }) value!: KwixeoCustomers.Contact|null
  @Prop({ default: null }) customer!: KwixeoCustomers.Customer|null
  @Prop({ default: true }) withRedirection!: boolean|undefined

  private loading = true
  private localContact: KwixeoCustomers.ContactForm = {
    customers: []
  }
  private address: Partial<KwixeoCustomers.Address> = {}
  private isBillingContact: null|boolean = null

  private editorConfig = editorConfig

  async mounted (): Promise<void> {
    await this.loadCountries()
    await this.loadContactFunctions()
    await this.setLocalContact(this.value)
    this.loading = false
  }

  get initialCountry (): string {
    if (this.localContact && this.address.country) {
      return this.address.country.code
    }
    return this.team?.country?.code ?? 'fr'
  }

  get apiFormUrl (): string {
    let url = '/customer/contact'
    if (this.localContact.id) {
      url += '/' + this.localContact.id
    }
    return url
  }

  private async setLocalContact (contact: KwixeoCustomers.ContactForm|null): Promise<void> {
    if (contact === null) {
      const local: KwixeoCustomers.ContactForm = {
        newsletter_inscription: this.teamConfigs.automatic_newsletter_subscription,
        function: this.defaultContactFunction,
        customers: []
      }
      if (this.customer) local.customers.push(this.customer)
      if (this.defaultContactFunction) local.function = this.defaultContactFunction
      this.localContact = local

      this.address = {
        country: this.team.country
      }
      return;
    } else if (contact.id && needFetchContact(contact)) {
      contact = await fetchContact(contact.id)
    }

    this.localContact = JSON.parse(JSON.stringify(contact))
    this.address = {
      road1: contact.road1,
      road2: contact.road2,
      road3: contact.road3,
      town: contact.town,
      postal_code: contact.postal_code,
      country: contact.country
    }

    this.isBillingContact = !this.value?.id ? null : this.localContact.customers[0]?.billing_contact_id === this.localContact.id
  }

  private async submitComplete (response: AxiosResponse): Promise<void> {
    const contact: KwixeoCustomers.Contact = response.data
    if (this.value && this.value.id) {
      emitter.emit('contactUpdated', {
        old: this.value,
        new: contact
      })
    } else {
      emitter.emit('contactCreated', contact)

      if (this.withRedirection) {
        await this.$router.push({
          name: 'contacts-contact-item',
          params: {
            id: String(contact.id)
          }
        })
      }
    }
  }
}
